import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { proMarketingInternalHref } from '../SEO/marketingCanonicalUrl';

function normalizeLinkTo(to: LinkProps['to']): LinkProps['to'] {
  if (typeof to === 'string') return proMarketingInternalHref(to);
  if (to && typeof to === 'object' && 'pathname' in to && typeof to.pathname === 'string') {
    return { ...to, pathname: proMarketingInternalHref(to.pathname) };
  }
  return to;
}

/** Link React Router avec slash final aligné sitemap / Pretty URL (#1164 / #1167). */
export default function ProMarketingLink({ to, ...rest }: LinkProps) {
  return <Link to={normalizeLinkTo(to)} {...rest} />;
}
